<template>
    <div class="header">
        <div class="top-bar">
            <div class="logo">
                <a data-v-4ea235ea="" href="/" title="">
                    <img src="https://svgshare.com/i/ERQ.svg" class="logo--pixelate">
                </a>
                <div class="menu-options"><span class="menu-action js-menu-action"><i></i></span></div>
            </div>
            <div class="quick-links">
                <span class="flag-icon"> <i class="fa fa-flag"></i>TR</span>
               
                <button class="btn btn-danger" style="margin-right:30px;" type="button" @click.prevent="logout">Çıkış Yap </button>
            </div>
        </div><!-- Top Bar -->
    </div>
</template>

<script>
    export default {
        methods: {
            logout() {
                this.$router.push('/logout')
            }
        },
    }
</script>

<style scoped>

</style>